import { useState, useRef } from "react";
import ReactDOM from "react-dom";
import { useNavigate, useParams } from "react-router-dom";
import testData from "../../testData.json"; // Assuming testData is in the same directory
import AddConvictions from "./addConvictions"
import DelConvliction  from "./delConvictions";
import PostUnlinkWithdrawals from "./postUnlinkwithdrawals.js"
import PostLinkWithdrawals from "./postLinkedWithdrawlas.js";
import { useEffect } from "react";
import Loading from "../tabs/loading";
import EditDriver from "./EditDriver";
import NewMxDriver from "./newMxDriver";
import { basePage, baseUrl } from "../consts/baseUrl";
import NegateWithdrawal from "./negateWithdrawal";
import moment from "moment";
import { useAuth } from "../../context/AuthContext.js";
import { buildLinkConvictionsToWithdrawal, buildNegateConviction, buildNegateWithdrawal, defaultConvictions, defaultDriverData, defaultWithdrawals, makeLicense, makePersonDetails, postJson, setDefaultConvictions, setDefaultDriverData, setDefaultWithdrawals } from "../../utils/data.jsx";
//import { response } from "express";


 
function HelpDeskDriverDetails() {
  const [tableData, setTableData] = useState([]);
  const { jurisdiction, license, latname, firstname, dob } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [displayError, setDisplayError] = useState(false);
  const [selectedConvictions, setSelectedConvictions] = useState([]);
  //const [trackConvictions, setTrackConvictions] = useState([]);
  const [selectedWithdrawals, setSelectedWithdrawals] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [deleteType, setDeleteType] = useState("");
  const [userExists, setUserExists] = useState(true);
  const [ formData, setFormData ] = useState();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  //const userState = "OR"; // Example user state, replace with actual user logic
  const user = 'admin'; // Example user, replace with actual user logic
  const navigate = useNavigate();
  const screenRef = useRef(null);
  const driverRef = useRef(null);
  const negateDropDown = {'OR':['Court Ordered Negate', 'Administrative Negate', 'Other '], 'MI':['Court removal', 'Departmental removal']}
    const {source, token, userState, email, roles} = useAuth();
  //const addedConvictions = [];

  const convertDate = (date) =>{
    return date.replaceAll("-", "");
  }


  useEffect(() => {
    const fetchData = async () => {
    const formData = {
      Source:{
          DataSource: "HelpDesk"
      },
      License: {
          JurisdictionOfIssue: jurisdiction,
          LicenseNumber: license
      }
    };
    try {
      const response = await fetch(`/api/details`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData),
      });
      const result = await response.json();
      console.log('API Response:', result);
      setTableData(result || []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  fetchData();
  }, [jurisdiction, license]);

  const testNull = {
    "PersonDetails": {
        "PersonName": {
            "SurName": null,
            "FirstName": null,
            "MiddleName": null,
            "Suffix": null
        },
        "PhysicalDetails": {
            "Sex": null
        },
        "DOB": null,
        "MailingAddress": {
            "Line1": null,
            "Line2": null,
            "City": null,
            "State": null,
            "Zip": null,
            "County": null,
            "Country": null
        }
    }
}
  
  const handleDeleteClick = (type) => {

    if(type === 'Conviction(s)' && selectedConvictions.length > 1){
      alert("One Allowed");
      return;
    }

    if(type === 'Withdrawal(s)' && selectedConvictions.length > 1){
      alert("One Allowed");
      return;
    }

    setDeleteType(type);
    setErrorMessage(`No ${type} have been selected. Please select the ${type} you wish to negate/delete.`);
    if (type === 'Conviction(s)' && selectedConvictions.length === 0) {
      setDisplayError(true);
      return;
    }
    if (type === 'Withdrawal(s)' && selectedWithdrawals.length === 0) {
      setDisplayError(true);
      return;
    }
    
    setShowModal(true);
  };
  const checkSelection = (buttonType) => {
    if(buttonType === 'updateWithdrawal' && (selectedWithdrawals.length === 0 || selectedWithdrawals.length > 1)) {
      setErrorMessage("Please only select one withdrawal to update at once.");
      setDisplayError(true);
      return;
    }
    if(buttonType === 'updateConviction' && (selectedConvictions.length === 0 || selectedConvictions.length > 1)) {
      setErrorMessage("Please only select one conviction to update at once.");
      setDisplayError(true);
      return;
    }
    if(buttonType === 'linkConvictions') {
      if(selectedWithdrawals.length === 0 || selectedWithdrawals.length > 1) {
        setErrorMessage("No Withdrawals have been selected. Please select the Withdrawal you wish to update.");
        setDisplayError(true);
        return;
      } else if(selectedConvictions.length === 0) {
        setErrorMessage("No Convictions have been selected. Please select the Conviction(s) you wish to link.");
        setDisplayError(true);
        return;
      }
    }
    if(buttonType === 'removeAllLinks' && selectedWithdrawals.length === 0) {
      setErrorMessage("No Withdrawals have been selected. Please select the Withdrawal from which you want to remove the link(s).");
      setDisplayError(true);
      return;
    }
  }

  const convertDrvObject = (tableData) => {

    const driverData = {
      "firstName"     : tableData?.PersonDetails?.PersonName?.FirstName,
      "middleName"    : tableData?.PersonDetails?.PersonName?.MiddleName,
      "surName"       : tableData?.PersonDetails?.PersonName?.SurName,
      "suffix"        : tableData?.PersonDetails?.PersonName?.Suffix,
      "dob"           : tableData?.PersonDetails?.DOB,
      "street1"       : tableData?.PersonDetails?.MailingAddress?.Line1,
      "street2"       : tableData?.PersonDetails?.MailingAddress?.Line2,
      "city"          : tableData?.PersonDetails?.MailingAddress?.City,
      "county"        : tableData?.PersonDetails?.MailingAddress?.County,
      "state"         : tableData?.PersonDetails?.MailingAddress?.State,
      "zip"           : tableData?.PersonDetails?.MailingAddress?.Zip,
      "country"       : tableData?.PersonDetails?.MailingAddress?.Country,
      "driverState"   : jurisdiction,
      "driverLicense" : license,
      "sex"           : "1", //tableData?.PersonDetails?.Sex 
    };

    return driverData;
  }

    if(JSON.stringify(tableData.PersonDetails) === JSON.stringify(testNull)){
    //Test conditions (no driver) for edit activiat
    //if(tableData.length === undefined){
      const driverData = convertDrvObject(tableData);

    try {    
      ReactDOM.render(<EditDriver driverData={driverData} />,
        driverRef.current); 
      } catch(err){
        alert(err)
      }

  }

  /*
  const handleWithdalDelete = (e) =>{

  }
*/
  const handleModalClose = () => {
    //setShowModal(false);
    setInputValue("");
    window.location.replace(basePage);
  };

  const handleSelctConvict = (e, id) => {

    if(!selectedConvictions.includes(id)){
        setSelectedConvictions(selectedConvictions => [...selectedConvictions, id]);
    } else {
        setSelectedConvictions(prevItems => prevItems.filter(item => item !== id));
    }
  }


  const handleInputChange = (e) => {
        setInputValue(e.target.value);
  }

  const handleModalSubmit = (e) => {
    e.preventDefault();
    //const deletes = [];
    // Do something with inputValue, e.g., call API or update state
    //alert(`You entered: ${inputValue}`);
    //handleModalClose();

    if (deleteType ===  'Conviction(s)'){
      const v = selectedConvictions-1;

      const temp = {
    "Header": {
        "Metadata": {
            "UserID": email
        }
    },
    "Body": {
        "Source":{
            "DataSource": source,
        },
        "PersonDetails": {
            "PersonName": {
                "SurName": tableData?.PersonDetails?.PersonName?.SurName,
                "FirstName": tableData?.PersonDetails?.PersonName?.FirstName,
                "MiddleName": tableData?.PersonDetails?.PersonName?.MiddleName,
                "Suffix": tableData?.PersonDetails?.PersonName?.Suffix
            },
            "PhysicalDetails": {
                "Sex": "1", //tableData?.PersonDetails?.PhysicalDetails?.Sex
            },
            "DOB": tableData?.PersonDetails?.DOB,

            "MailingAddress": {
                "Line1": tableData?.PersonDetails?.MailingAddress?.Line1,
                "Line2": tableData?.PersonDetails?.MailingAddress?.Line2,
                "City": tableData?.PersonDetails?.MailingAddress?.City,
                "State": tableData?.PersonDetails?.MailingAddress?.State,
                "Zip": tableData?.PersonDetails?.MailingAddress?.Zip,
                "County": tableData?.PersonDetails?.MailingAddress?.County,
                "Country": tableData?.PersonDetails?.MailingAddress?.Country
            }
        },
        "License": {
            "JurisdictionOfIssue": jurisdiction,
            "LicenseNumber": license
        },
        "Convictions": {
              "JurisdictionCodeConvicting": "QC", //testData[v].StateNativeCode,
              "CitationDate": convertDate(testData.convictions[v].CitationDate),
              "ConvictionDate": convertDate(testData.convictions[v].ConvDate),
              "ConvictionCourtType": testData.convictions[v].CourtType,
              "ConvictionCommercialVehInd":  testData.convictions[v]?.CMV,
              "ConvictionHazmatInd": testData.convictions[v].HazMat,
              "CDLIndicator": testData.convictions[v].CDL,
              "ConvictionJurisCourtReportId": testData.convictions[v].SOC,
              "ConvictionJurisdictionOffenseCode": testData.convictions[v].ConvOffenseLoc,
              "ConvictionOffenseAcdCode": testData.convictions[v].ACD,
              "ConvictionOffenseDetailAcd": testData.convictions[v].Detail,
              "ConvictionStatusNotes": inputValue,
              "ConvictionUserId": testData.convictions[v].UserID
          }
        }
      }

      try {    
        ReactDOM.render(<DelConvliction data={temp} />,
            screenRef.current); 
      } catch(err){
        alert(err)
      }
    }

    if(deleteType === 'Withdrawal(s)'){
      alert("Deleting Withdrawals")
/*
      const temp = {};

      try {    
        ReactDOM.render(<NegateWithdrawal data={temp} />,
            screenRef.current); 
      } catch(err){
        alert(err)
      }
        */
    }
  };


  if(loading) {
    return(
      <>
      <Loading />
      </>
    )
  }


  const handleEditDriver = (e) => {
    e.preventDefault();
    const driverData = convertDrvObject(tableData);

    try {    
      ReactDOM.render(<EditDriver driverData={driverData} />,
        driverRef.current); 
      } catch(err){
        alert(err)
      }
  }

  const handlAddConvictions = (e, tableData) => {
    e.preventDefault();

    try {    
      ReactDOM.render(<AddConvictions data={tableData} />,
        screenRef.current); 
      } catch(err){
        alert(err)
      }
  }

  
  if(!userExists) {
    return (
      <div className="App"><h1>Driver Details Create User</h1>
      <form id="Index-form">
      <div>
        <tr>
            <td className="col-md-3">Driver State</td>
            <td className="col-md-3">Driver License</td>
        </tr>
        <tr>
            <td className="col-md-3"><input class="form-control" type="text" placeholder={jurisdiction} disabled /></td>
            <td className="col-md-3"><input class="form-control" type="text" placeholder={license} disabled /></td>
        </tr>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} >Save</button>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} >Close</button>
      </div>
        
        <div id="table" style={{fontSize: 'medium'}}>
        <h3>Driver General Information</h3>
        <table className="table table-striped table-bordered">
        
        <thead style={{width: '100%'}}>
            <tr>
                <th scope="col">First Name</th>
                <th scope="col">Middle Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Suffix</th>
                <th scope="col">Date of Birth</th>
            </tr>
        </thead>
        </table>
        <h3>Residence</h3>
        <table className="table table-striped table-bordered">
        
        <thead style={{width: '100%'}}>
            <tr>
            <th>Street Address1</th>
            <th>Street Address2</th>
            <th>City</th>
            <th>County</th>
            <th>State</th>
            <th>Zip code</th>
            <th>Country</th>
          </tr>
        </thead>
        </table>
        </div>
        </form>
      </div>
    );
  }

  return (
    <div className="App" ref={screenRef}>
      <h1>Driver Details</h1>
      <div>
        <tr>
            <td className="col-md-3">Driver State</td>
            <td className="col-md-3">Driver License</td>
        </tr>
        <tr>
            <td className="col-md-3"><input class="form-control" type="text" placeholder={jurisdiction} disabled /></td>
            <td className="col-md-3"><input class="form-control" type="text" placeholder={license} disabled /></td>
        </tr>
        <div ref={driverRef} >
          <button type="button" className="btn btn-primary" 
          id="button" form='Index-form' style={{"textAlign": "start"}} 
          onClick={(e) => handleEditDriver(e)}
          >Search</button>

        <button type="button" className="btn btn-primary" 
          id="button" form='Index-form' style={{"textAlign": "start"}} 
          onClick={handleModalClose}
          >Search FCWD ONLY</button>

          <button type="button" className="btn btn-primary" 
          id="button" form='Index-form' style={{"textAlign": "start"}} 
          onClick={handleModalClose}
          >Review Complete</button>
      
        <div id="table" style={{fontSize: 'medium'}}>
        <h3>Driver General Information</h3>
        <table className="table table-striped table-bordered">
        
        <thead style={{width: '100%'}}>
            <tr>
                <th scope="col">Driver First Name</th>
                <th scope="col">Driver Middle Name</th>
                <th scope="col">Driver Last Name</th>
                <th scope="col">Driver Suffix</th>
                <th scope="col">Driver Date of Birth</th>
                <th scope="col">Driver Sex</th>
                <th scope="col">Height</th>
                <th scope="col">Weight</th>
                <th scope="col">Eye Color</th>

            </tr>
        </thead>
        <tbody>
          <tr>
                <td scope="col">{tableData?.PersonDetails?.PersonName?.FirstName}</td>
                <td scope="col">{tableData?.PersonDetails?.PersonName?.MiddleName}</td>
                <td scope="col">{tableData?.PersonDetails?.PersonName?.SurName}</td>
                <td scope="col">{tableData?.PersonDetails?.PersonName?.Suffix}</td>
                <td scope="col">{tableData?.PersonDetails?.DOB}</td>
                <td scope="col">{tableData?.PersonDetails?.PhysicalDetails.Sex}</td>
                <td scope="col">{tableData?.PersonDetails?.PhysicalDetails.Height}</td>
                <td scope="col">{tableData?.PersonDetails?.PhysicalDetails.Weight}</td>
                <td scope="col">{tableData?.PersonDetails?.PhysicalDetails.EyeColor}</td>
            </tr>
        </tbody>
        </table>
        <h3>Residence</h3>
        <table className="table table-striped table-bordered">
        
        <thead style={{width: '100%'}}>
            <tr>
            <th>Street Address1</th>
            <th>Street Address2</th>
            <th>City</th>
            <th>County</th>
            <th>Residence State</th>
            <th>Zip</th>
            <th>Country</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{tableData?.PersonDetails?.MailingAddress?.Line1}</td>
            <td>{tableData?.PersonDetails?.MailingAddress?.Line2}</td>
            <td>{tableData?.PersonDetails?.MailingAddress?.City}</td>
            <td>{tableData?.PersonDetails?.MailingAddress?.County}</td>
            <td>{tableData?.PersonDetails?.MailingAddress?.State}</td>
            <td>{tableData?.PersonDetails?.MailingAddress?.Zip}</td>
            <td>{tableData?.PersonDetails?.MailingAddress?.Country}</td>
          </tr>
        </tbody>
        </table>
        <th>Driver License Details</th>
          <table className="table table-striped table-bordered">
              <thead>
                  <tr>
                      <th scope="col">Issue Date</th>
                      <th scope="col">Expiration Date</th>
                      <th scope="col">Commercial Class</th>
                      <th scope="col">Commercial Status</th>
                      <th scope="col">Withdrawal Action Pending</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>20000424</td>
                      <td>20221123</td>
                      <td>A</td>
                      <td>Not Eligible</td>
                      <td>No</td>
                  </tr>
              </tbody>
          </table>
          <th>Medical Certifications</th>
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Issue Date(YYYYMMDD)</th>
                <th>Expiration Date(YYYYMMDD)</th>
                <th>Status Code</th>
                <th>Self Certification</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{tableData?.medCert?.IssueDate || '20251231'}</td>
                <td>{tableData?.medCert?.ExpirationDate || '20261109'}</td>
                <td>{tableData?.medCert?.StatusCode?.split('-')[1] || tableData?.medCert?.StatusCode}</td>
                <td>{tableData?.medCert?.SelfCertificationCode || tableData?.medCert?.SelfCertification}</td>
              </tr>
            </tbody>
          </table>
          <th>Endorsements</th>
          <table className="table table-striped table-bordered">
            <thead>
              <tr><th>Value</th></tr>
            </thead>
            <tbody>
              {/* {endorsements.map((item, index) => ( */}
                <td>Doubles/Triples</td>
                <td>Combination of Tank Vehicle</td>
                <td>Passenger</td>
                <td>School Bus</td>
                <td>Hazardous Materials</td>
               {/*}))} */}
            </tbody>
          </table>
          <th>License Restrictions</th>
          <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Restriction</th>
                </tr>
              </thead>
              <tbody>
                {/* {restrictions.map((item, index) => ( */}
                  <td>Glasses</td>
                  <td>Outside Mirror</td>
                  <td>Limited to Employment</td>
                  <td>Daylight Only</td>
                {/* ))} */}
              </tbody>
          </table>
          <th>History Comments for Delete of Convictions and Withdrawals</th>
          <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Comment</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                </tr>
            </tbody>
          </table>
        </div>
        </div>
        <h3>Convictions</h3>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}}
        //onClick={() => navigate('/addconviction')}
        onClick={(e)=> handlAddConvictions(e, tableData)}
        >
          Add Convictions</button>
        <button
            type="button"
            className="btn btn-primary"
            id="button"
            form="Index-form"
            style={{ textAlign: "start" }}
            onClick={() => handleDeleteClick('Conviction(s)')}
        >
            Delete/Negate Conviction
        </button>
        {user === 'admin' &&
        <button
            type="button"
            className="btn btn-primary"
            id="button"
            form="Index-form"
            style={{ textAlign: "start" }}
            onClick={() => checkSelection('updateConviction')}
        >
            Update Conviction
        </button>}
        <div className="table-responsive">
        <table className="table table-striped table-bordered table-sm" style={{fontSize: 'x-small'}}>
        <thead style={{width: '100%'}}>
            <tr>
                <th scope="col">Select</th>
                <th scope="col">Driver State</th>
                <th scope="col">Driver License</th>
                <th scope="col">Citation Date</th>
                <th scope="col">Conv Date</th>
                <th scope="col">Conv ID</th>
                <th scope="col">SOC</th>
                <th scope="col">Court Type</th>
                <th scope="col">ACD</th>
                <th scope="col">Detail</th>
                <th scope="col">CDL</th>
                <th scope="col">CMV</th>
                <th scope="col">Haz Mat</th>
                <th scope="col">Conv Offense Loc</th>
                <th scope="col">State Native Code</th>
                <th scope="col">Category</th>
                <th scope="col">User ID</th>
                <th scope="col">Date Posted</th>
            </tr>
        </thead>
        <tbody>
          {testData.convictions.map(conviction => (
            <tr>
                
            {
              conviction.SOC === userState ? 
          <td>
              <input type="checkbox" aria-label="Checkbox for following text input" 
                onChange={(e) => handleSelctConvict(e, conviction.id)}/>
              </td> :
              <td>
                <input type="checkbox" aria-label="Checkbox for following text input" disabled/>
            </td>
            }

            <td id="cState">{conviction.DriverState}</td>
            <td id="cLicense">{conviction.DriverLicense}</td>
            <td id="cCitationDate">{conviction.CitationDate}</td>
            <td id="cConvDate">{conviction.ConvDate}</td>
            <td id="convID">{conviction.ConvID}</td>
            <td id="SOC">{conviction.SOC}</td>
            <td id="cCourt">{conviction.CourtType}</td>
            <td id="cACD">{conviction.ACD}</td>
            <td id="cDetail">{conviction.Detail}</td>
            <td id="cCDL">{conviction.CDL}</td>
            <td id="CMV">{conviction.CMV}</td>
            <td id="cHazmat">{conviction.HazMat}</td>
            <td id="cConvOff">{conviction.ConvOffenseLoc}</td>
            <td id="cStateNative">{conviction.StateNativeCode}</td>
            <td id="cCategory">{conviction.Category}</td>
            <td id="cUserID">{conviction.UserID}</td>
            <td id="cDatePosted">{conviction.DatePosted}</td>
            </tr>
            ))}
            

        </tbody>
        </table>
        </div>
        <h3>Withdrawals</h3>
        <button type="button" className="btn btn-primary" 
            // onClick={(e) => handleAddWithdrawal(e)}
            onClick={() => navigate('/addwithdrawal')}
            id="button" form='Index-form' style={{"textAlign": "start"}}>
              Add Withdrawal
        </button>
        {user === 'admin' &&
        <button type="button" className="btn btn-primary" 
            // onClick={(e) => handleAddWithdrawal(e)}
            onClick={() => navigate('/staging/addwithdrawal')}
            id="button" form='Index-form' style={{"textAlign": "start"}}>
              Add Staging Withdrawal
        </button>}
        <button
            type="button"
            className="btn btn-primary"
            id="button"
            form="Index-form"
            style={{ textAlign: "start" }}
            onClick={() => handleDeleteClick('Withdrawal(s)')}
        >
            Delete/Negate Withdrawal
        </button>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} onClick={() => checkSelection('updateWithdrawal')}>Update Withdrawal</button>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} onClick={() => checkSelection('linkConvictions')}>Link Convictions</button>
        <button type="button" className="btn btn-primary" id="button" form='Index-form' style={{"textAlign": "start"}} onClick={() => checkSelection('removeAllLinks')}>Remove All Links From Withdrawal</button>
        <div className="table-responsive">
        <table className="table table-striped table-bordered table-sm" style={{fontSize: 'x-small'}}>
        <thead style={{width: '100%'}}>
          {user === 'admin' ?
          <tr>
                <th scope="col">Select</th>
                <th scope="col">Effective Date</th>
                <th scope="col">Elig Date</th>
                <th scope="col">State</th>
                <th scope="col">WDraw ID</th>
                <th scope="col">Linkage</th>
                <th scope="col">ACD Code</th>
                <th scope="col">Action</th>
                <th scope="col">Manual/Electronic</th>
                <th scope="col">Basis</th>
                <th scope="col">Extent</th>
                <th scope="col">WD Locator Ref</th>
                <th scope="col">Reason Ref Code</th>
                <th scope="col">Due Proc Status</th>
                <th scope="col">User ID</th>
                <th scope="col">Notice Period</th>
                <th scope="col">Duration</th>
                <th scope="col">Reinstate Date</th>
                <th scope="col">Needs Reins Letter</th>
                <th scope="col">Reins Letter Sent</th>
                <th scope="col">Needs Disq Letter</th>
                <th scope="col">Disq Letter Sent</th>
                <th scope="col">Category</th>
                <th scope="col">Withdrawal Received</th>
                <th scope="col">Withdrawal Posted</th>
                <th scope="col">DQ Mailed Date</th>
            </tr>
          :
            <tr>
                <th scope="col">Select</th>
                <th scope="col">Driver State</th>
                <th scope="col">Driver License</th>
                <th scope="col">Effective Date</th>
                <th scope="col">Eligibility Date</th>
                <th scope="col">Reinstatement Date</th>
                <th scope="col">SOW</th>
                <th scope="col">Withdrawal ID</th>
                <th scope="col">Link</th>
                <th scope="col">ACD Code</th>
                <th scope="col">Action</th>
                <th scope="col">Basis</th>
                <th scope="col">Extent</th>
                <th scope="col">Due Process Status</th>
                <th scope="col">WD Locator Number</th>
                <th scope="col">State Native Code</th>
                <th scope="col">User ID</th>
                <th scope="col">Date Posted</th>
            </tr>
          }
        </thead>
        <tbody>
          {testData.withdrawals.map(withdrawal => (
            <tr>
                
            {withdrawal.SOW === userState ? <td><input type="checkbox" aria-label="Checkbox for following text input" checked={selectedWithdrawals.includes(withdrawal.WithdrawalID)} 
              onChange={e => {
                if(e.target.checked){
                  setSelectedWithdrawals([...selectedWithdrawals, withdrawal.WithdrawalID]);
                } else {
                  setSelectedWithdrawals(selectedWithdrawals.filter(id => id !== withdrawal.WithdrawalID));
                }
              }}/></td> :
            <td><input type="checkbox" aria-label="Checkbox for following text input" disabled/></td>}
            {user === 'admin' ?
            <>
            <td>20181214</td>
            <td>20231214</td>
            <td>WI</td>
            <td>A0</td>
            <td></td>
            <td>NO1 - FAIL TO YIELD RIGHT OF WAY</td>
            <td>Suspended</td>
            <td>E</td>
            <td>Administrative Action</td>
            <td>All</td>
            <td>WI SUS S214381</td>
            <td>FCC</td>
            <td>Not Defined</td>
            <td>WI</td>
            <td></td>
            <td></td>
            <td></td>
            <td>false</td>
            <td></td>
            <td>false</td>
            <td></td>
            <td>Other</td>
            <td>20181218</td>
            <td>20181218</td>
            <td></td>  
            </>:
            <>
            <td id="wstate">{withdrawal.DriverState}</td>
            <td id="wLicense">{withdrawal.DriverLicense}</td>
            <td id="wEffectiveDate">{withdrawal.EffectiveDate}</td>
            <td id="wEligibilityDate">{withdrawal.EligibilityDate}</td>
            <td id="wReinstatementDate">{withdrawal.ReinstatementDate}</td>
            <td id="SOW">{withdrawal.SOW}</td>
            <td id="wID">{withdrawal.WithdrawalID}</td>
            <td id="wLink">{withdrawal.Link}</td>
            <td id="wACDCode">{withdrawal.ACDCode}</td>
            <td id="wAction">{withdrawal.Action}</td>
            <td id="wBasis">{withdrawal.Basis}</td>
            <td id="wExtent">{withdrawal.Extent}</td>
            <td id="wDueProcess">{withdrawal.DueProcessStatus}</td>
            <td id="wDLocator">{withdrawal.WDLocatorNumber}</td>
            <td id="wStateNative">{withdrawal.StateNativeCode}</td>
            <td id="wUserID">{withdrawal.UserID}</td>
            <td id="wDatePosted">{withdrawal.DatePosted}</td>
            </>
            }
            </tr>
          ))}

        </tbody>
        </table>
        </div>
        </div>
        {/* Bootstrap Modal */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form onSubmit={(e) => handleModalSubmit(e)}>
              <div className="modal-header">
                <h5 className="modal-title">Comments for Negate/Delete of {deleteType}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                />
              </div>
              <div className="modal-body">
                  <div class="form-group">
                    <label for="message-text" class="col-form-label">Reason for Negate/Delete</label>
                    {userState in negateDropDown ?
                    <select class="form-select" aria-label="Default select example"
                      value={inputValue}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="" disabled selected>Select your option</option>
                      {negateDropDown[userState].map((option, index) => (
                        <option key={index} value={option}>{option}</option>
                      ))}
                    </select> :
                    <input
                      type="text"
                      value={inputValue}
                      onChange={handleInputChange}
                      placeholder="Reason"
                      style={{ width: "100%", marginBottom: 12 }}
                      required
                    />}
                  </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-danger"
                >
                  Delete
                </button>
              </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {displayError && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Error</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setDisplayError(false)}
                />
              </div>
              <div className="modal-body">
                <p>
                  {errorMessage}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default HelpDeskDriverDetails;